// This file is automatically generated. Do not edit manually.

import { CostEventObjectRef } from "src/api/generated/erp/common/costEvents/model/costEventObjectRef";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CostEventsOfObjectMailApi {
	export async function sendCostEventsOfObject(args: {
		objectRef: CostEventObjectRef;
		receiverEmail: string;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/costEvents/costEventsMail/sendCostEventsOfObject",
			method: "POST",
			data: {
				objectRef: args.objectRef,
				receiverEmail: args.receiverEmail,
			},
		});
		return response as void;
	}
}
